<template>
    <div class="preview">
        <div class="container" ref="container" ></div>

        <!-- 标注 -->
        <billboard ref="billboard" v-if="readyScene"></billboard>
    </div>
</template>

<script>
import InitMixin from '@/mixins/sceneInit'
import Billboard from '../Editor/Billboard.vue'

export default {

    mixins: [ InitMixin ],

    components: {
        Billboard
    },

    mounted(){
        this.init( true )
    },

    methods: {

    }
}
</script>
<style lang="scss" scoped>
.preview{
    width: 100vw; height: 100vh; position: relative; padding: 0; margin: 0; overflow: hidden;
    .container{ width: 100%; height: 100%; }
}
.btn{
    width: 88px; height: 34px; border-radius: 17px; text-align: center; line-height: 34px; position: fixed; top: 30px; cursor: pointer;
}
.btn_1{
    background-color: #1458EA; color: #FFF; left: 30px;
}
</style>
